import Select from "../plugins/Select";
import Form from "../classes/Form";

$(document).ready(function () {
    /**
     * Объект формы
     * @type {jQuery}
     */
    const form = $('#form_to');

    /**
     * Объект формы с VIN
     * @type {jQuery}
     */
    const formVin = $('#form_to-vin');

    if (form.length === 0 && formVin.length === 0) {
        return;
    }

    /**
     * Объект input с vin
     * @type {jQuery}
     */
    const vinInput = formVin.find('[name=vin]');

    /**
     * Объект селекта с моделями
     * @type {jQuery}
     */
    const modelSelect = form.find('[name=model]');

    /**
     * Объект селекта с комплектациями
     * @type {jQuery}
     */
    const complectationsSelect = form.find('[name=complectation]');

    /**
     * Объект кнопки сабмита
     * @type {jQuery}
     */
    const submit = form.find('[type=submit]');

    /**
     * Объект спика для ТО
     * @type {jQuery}
     */
    const toList = $('#to-list');

    /**
     * @function
     * Ивент при изменении селекта с моделями
     * @see modelSelect
     */
    function onModelChange(e) {
        disableSubmit();
        const val = $(e.target).val();
        if (val) {
            $.ajax({
                type: 'POST',
                dataType: 'JSON',
                data: {model: val},
                url: '/ajax/TO/update-complectations/',
                success: data => {
                    if (data.status === 'ok') {
                        updateComplectations(data.complectations);
                    } else {
                        console.warn('ERROR IN AJAX. Message: ', data.message);
                    }
                },
                complete: enableSubmit()
            });
        } else {
            updateComplectations([]);
            enableSubmit();
        }
    }

    /**
     * @function
     * Отключаем клик по кнопке сабмита
     * @see submit
     */
    function disableSubmit() {
        submit.attr('disabled', 'disabled').prop('disabled', true);
    }

    /**
     * @function
     * Включаем клик по кнопке сабмита
     * @see submit
     */
    function enableSubmit() {
        submit.removeAttr('disabled').prop('disabled', false);
    }

    function updateComplectations(complectations) {
        let options = '';
        if (complectations.length) {
            for (const complectation of complectations) {
                options += `<option value="${complectation.id}">${complectation.modification_name} ${complectation.name}</option>`;
            }
            complectationsSelect.removeAttr('disabled');
        } else {
            complectationsSelect.attr('disabled', 'disabled');
        }

        complectationsSelect.html(options);
        Select.get(form).update(complectationsSelect);
    }

    /**
     * @function
     * Ивент при сабмите формы
     * @param {Object} e
     * @see {form, submit}
     */
    function onFormSubmit(e) {
        e.preventDefault();
        const form = $(e.target);
        const object = Form.get(`#${e.target.id}`);
        updateList('');

        if (!object.isValid())
            return false;

        sendAjax(form);
    }

    function sendAjax(form) {

        $.ajax({
            type: 'POST',
            dataType: 'JSON',
            data: form.serialize(),
            url: '/ajax/TO/get-list/',
            success: data => {
                if (data.status === 'ok') {
                    updateList(data.list);
                } else {
                    console.warn('ERROR IN AJAX. Message: ', data.message);
                }
            },
            complete: enableSubmit()
        });
    }

    /**
     * @function
     * Ивент при сабмите формы с Vin
     * @param {Object} e
     * @see {formVin}
     */
    function onFormVinSubmit(e) {
        e.preventDefault();
        const object = Form.get(`#${e.target.id}`);
        const form = $(e.target);
        updateList('');

        if (!object.isValid())
            return false;

        $.ajax({
            type: 'POST',
            dataType: 'JSON',
            data: form.serialize(),
            url: '/ajax/TO/try-vin/',
            success: data => {
                if (data.status === 'ok') {
                    updateList(data.list);
                    handleErrorMessage(form, '');
                } else {
                    if (data.showMessage) {
                        handleErrorMessage(form, data.message);
                    }
                    console.warn('ERROR IN AJAX. Message: ', data.message);
                }
            },
            complete: enableSubmit()
        });
    }

    /**
     * Показать или крыть сообщение об ошибке
     * @param {!jQuery} form
     * @param {!string=} message
     */
    function handleErrorMessage(form, message = '') {
        form.find('.error-message').html(message);
    }

    /**
     * @function
     * Вставляем полученные данные по ТО
     * @param {string} html
     */
    function updateList(html) {
        toList.html(html);
    }
    form.submit(onFormSubmit);
    formVin.submit(onFormVinSubmit);
    modelSelect.change(onModelChange);

});